<template>
  <b-container fluid class="px-0 position-relative">
    <deactive-food v-if="!value.IsAvailable" class="position-absolute p-2 font-weight-bold" style="top: 60px; right: 20px"/>
    <b-row class="mb-4 h-100">
      <b-col class="h-100">
        <div class="d-flex flex-row justify-content-between">
          <section class="d-flex">
            <div @click="openPhotoModal" class="position-relative food-image-item" style="width: 140px">
              <div v-if="value.IsNew" class="new-tag text-white font-weight-bold">
                New
              </div>
              <b-img v-if="!value.Video1" class="cursor-pointer" :src="getImage(value.Photo1)" height="100" width="140" style="object-fit: contain;"/>
              <div v-if="value.Video1" style="position: relative; display: inline-block; height: 100px; width: 140px;">
                <b-img class="cursor-pointer" :src="getImage(value.VideoThumbnail || value.Photo1)" height="100" width="140" style="object-fit: contain;"/>
                <img src="../../../../../assets/image/video-play-button.png" alt="Play Video" style="position: absolute; top: 50%; left: 50%; width: 72px; height: 72px; transform: translate(-50%, -50%); pointer-events: none;"/>
              </div>
            </div>
            <div class="px-3">
              <div class="d-flex" :style="{'gap':'0.2rem'}">
                <p v-if="value.ReferenceID != ''" class="font-weight-bold cursor-pointer" :style="{'text-decoration': 'underline', 'text-underline-offset': ''}">
                    {{ value.ReferenceID }}
                  </p>
                  
                <p class="mb-0 font-weight-bold cursor-pointer" @click="openEdit">
                  
                  {{value.Name}} <font-awesome-icon icon="pencil-alt" class="ml-1 cursor-pointer" style="font-size: 0.8rem; color: grey"/>
                </p>
                <div class="ml-4">
                <img @click="duplicate" src="/img/duplicate-menu-icon.png" alt="Duplicate Menu" style="width: 17px; height: 17px;">
          
              </div>
                <span
                  class="d-flex align-items-center cursor-pointer chef-pick ml-3"
                  @click.stop="toggleChefPick"
                >
                  <img
                    :src="value.ChefPick ? '/img/chef-picked.png' : '/img/chef-unpicked.png'"
                    alt="Chef Pick"
                    style="height: 1.8rem; margin-left: 5rem;"
                  >
                </span>
              
              </div>
              
              <p v-if="value.Name_SecondLang && AllowSecondLang" style="color:#78909C;" @click="openEdit" class="mb-0 font-weight-bold cursor-pointer"> {{value.Name_SecondLang}}</p>
              <p class="mb-0 font-weight-bold d-flex cursor-pointer" @click="openEdit">
                <currency-display v-if="value.Price > -0.1" v-model="value.Price"/>
                <span v-if="isMultiPrice(value)"
                  :id="`${value.ID}_food`"
                >
                  +
                </span>
                <span class="font-weight-normal text-nowrap mx-3" v-if="showCalorie(value).hasCalorie">
                  {{showCalorie(value).minCalorie}}{{showCalorie(value).multiCalorie ? '+' : ''}}
                  Cal
                </span>
                <template name="options">
                  <span class="ml-2 d-none d-lg-block">
                    <item-options :value="getOptions"/>
                  </span>
                  <span class="small font-weight-normal ml-2" style="font-size: 12px; margin-top: 3px" v-if="value.ABV && value.ABV >= 0">ABV: {{value.ABV}}%</span>
                </template>
              </p>
              <p class="mb-0 small d-none d-lg-block" style="font-style: italic">
                {{value.Desc}}
              </p>
            </div>
          </section>
          <section class="d-flex">
            <b-btn size="sm" style="height: 28px" variant="danger" class="mr-5" @click="deleteConfirmation">
              <font-awesome-icon icon="trash" class="align-middle"/>
            </b-btn>
            <c-switch
              color="warning"
              v-model="value.IsAvailable"
              @click="confirmationAvailable(value.IsAvailable)"
              label
              dataOn="on" dataOff="off"/>
          </section>
        </div>
      </b-col>
    </b-row>
    <div class="d-block d-lg-none">
      <div class="font-weight-bold mb-2">
        <item-options :value="getOptions"/>
      </div>
      <p class="mb-2 small" style="font-style: italic">
        {{value.Desc}}
      </p>
    </div>
    <b-row class="d-flex flex-row justify-content-end pr-4" v-if="value.MenuboardTVName != '' && value.MenuboardTVName != null" >
      <p style="border:1px,solid,black" class="p-1">{{value.MenuboardTVName}}</p>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="mb-2" v-if="value.ModifierCategories && value.ModifierCategories.length">
          <Mlabel title="Modifier Groups">
            <span style="white-space: normal;word-wrap: break-word;">
              {{getModifierName(value)}}
            </span>
          </Mlabel>
        </div>
        <div class="mb-2 cursor-pointer" v-if="loyaltyPermission && applicableLoyaltyRewards.length" @click="openEdit">
          <Mlabel title="Loyalty Rewards">
            <span style="white-space: normal;word-wrap: break-word;">
              <span
                v-for="(reward, index) in applicableLoyaltyRewards"
                :key="reward.RewardID"
                :style="{textDecoration: (!loyaltyAllowance || reward.Status !== 'active') ? 'line-through' : 'none', color: (!loyaltyAllowance || reward.Status !== 'active') ? '#c8ced3' : ''}"
              >{{reward.Name}}<template v-if="index < applicableLoyaltyRewards.length - 1">, </template></span>
            </span>
          </Mlabel>
        </div>
        <div class="mb-2">
          <Mlabel title="Ingredients">
            <span style="white-space: normal;word-wrap: break-word;">
                {{value.Ingredients}}
            </span>
          </Mlabel>
        </div>
        <div class="mb-2 d-flex flex-row justify-content-between">
          <Mlabel v-if="value.VisibleTags" title="File Name (Uploaded Photo)">
            <span>
                {{value.OriginalPhotoFile1}}
            </span>
          </Mlabel>
          <Mlabel v-if="value.VisibleTags" title="ID">
            <span>
                {{value.ID}}
            </span>
          </Mlabel>
        </div>
<!--        $hasPermission([2]) && value.IsAvailable-->
        <div v-if="value.VisibleTags">
          <Mlabel title="Tags">
            <span style="white-space: normal;word-wrap: break-word;">
                {{value.Tags}}
            </span>
          </Mlabel>
        </div>
      </b-col>
    </b-row>
    <delete-confirmation v-model="deleteModal" :progressing="deleteLoading" :food="value" @refresh="deleteFood"/>
    <status-confirmation v-model="confirmationChangeStatus" :progressing="deleteLoading" :food="value" @refresh="changeAvailable"/>
    <edit-food
      v-model="editModal"
      :updated="editModal"
      :item="value"
      :foods="foods"
      :availableCategories="availableCategories"
      :AllowSecondLang="AllowSecondLang"
      :edible-type="edibleType"
      :category="category"
      @refresh="refreshFood"
      @deleteConfirmation="deleteConfirmation"
      :kds="kds"
      :display="display"
    />
    <upload-photo
      :title="currentPhoto ? 'Item Photo Change' : 'Item Photo Upload'"
      first-content=""
      hide-header
      second-content=""
      v-model="photoModal"
      :has-photo="!!currentPhoto"
      :ratio="16/9"
      hide-header
      @upload="upload"
      @delete="deletePhoto"
      :progressing="progressing"

    >
      <template #content>
        <div class="font-weight-bold text-center" style="color: red">
          {{value.Name}}
        </div>
        <div class="mt-3 position-relative" v-if="currentPhoto">
          <div v-if="value.Credit" class="position-absolute bg-white p-2 credit-box">
            Credit : {{value.Credit}}
          </div>
          <b-img fluid-grow :src="getImage(currentPhoto)" style="object-fit: contain; max-height: 60vh; max-width: 100%;"/>
        </div>
        <div class="mt-3 bg-secondary text-center font-weight-bold d-flex align-items-center justify-content-center" style="height: 300px; color: #a7a7a7" v-else>
          No Photo Available
        </div>

        <div class="d-flex justify-content-center mt-3">
          <div class="photo-toggle-group">
            <button
              type="button"
              class="photo-toggle-btn"
              :class="{active: photoTarget === 'primary photo'}"
              @click="photoTarget = 'primary photo'"
            >Primary Photo</button>
            <button
              type="button"
              class="photo-toggle-btn"
              :class="{active: photoTarget === 'secondary photo'}"
              @click="photoTarget = 'secondary photo'"
            >Secondary Photo</button>
          </div>
        </div>

        <div class="mt-3 font-weight-bold h5">
          {{currentPhoto ? 'Item Photo Change' : 'Item Photo Upload'}}
        </div>
        <div class="mt-3">
          Upload a jpg, png, or gif file under 10MB with the following sizes for best results:

        </div>
        <div> Use images with 16:9 size aspect ratio (e.g. resolution 1600 by 900 pixel)
        </div>

        <div class="mt-3" v-if="$hasPermission([0, 1, 2, 3, 4, 5])">
          <b-form-checkbox
            id="CreditName"
            v-model="CreditName"
            name="CreditName"
            :value="true"
            :unchecked-value="false"
          >
            Add photo credit (Your name will be mentioned on the new photo.Do NOT check the box if you are not the photographer.)
          </b-form-checkbox>
        </div>
        <div class="mt-3" v-if="$hasPermission([0, 1, 2, 3, 4, 5])">
          <b-form-checkbox
            id="CopyrightName"
            v-model="CopyrightName"
            name="CopyrightName"
            :value="true"
            :unchecked-value="false"
          >
            Add Menupoly copyright notice
          </b-form-checkbox>
        </div>


        <div class="mt-3" v-if="priceCommentsList.length && value.Price">
          <b-form-group>
            <b-input-group prepend="New photo is for">
              <b-select :options="priceCommentsList" id="ShowPhotoFor" v-model="ShowPhotoFor" text-field="value" value-field="value"/>
            </b-input-group>
          </b-form-group>
        </div>
      </template>
    </upload-photo>
    <item-image v-model="currentPhotoItemModal" :item="value"/>
    <c-modal
      v-model="duplicateModal"
      size="lg"
      centered
      no-fade
      :tag="false"
      title="Duplicate Item Confirmation"
      confirm-label="Yes, Duplicate Item"
      cancel-label="No, Never mind"
      :progressing="duplicateLoading"
      @submit="duplicateFood"
    >
      <template>
        <div class="mb-4 text-center">
          Do you want to make a copy of  <b>{{value.Name}}</b> in the following menu & category?
        </div>
        <div class="mb-4 text-center">
          Choose a destination menu and category for the copy
        </div>
 
        <div v-if="destinationLoading" class="text-center py-2">
          <b-spinner small class="mr-2"/> Loading menu types...
        </div>
        <template v-else>
          <b-container >
            <b-row class="mt-3">
              <b-col cols="6">
              <b-form-group>
                <b-input-group prepend="Menu Type" class="mb-3">
                  <b-select
                    v-model="selectedMenuTypeID"
                    value-field="MenuTypeID"
                    text-field="Name"
                    :options="destinationMenuTypes"
                    @change="onMenuTypeChange"
                  />
                </b-input-group>
              </b-form-group>
              </b-col>
              <b-col cols="6">
              <b-form-group>
                <b-input-group prepend="Category">
                  <b-select
                    v-model="selectedCategoryID"
                    value-field="CategoryID"
                    text-field="Name"
                    :options="destinationCategories"
                  />
                </b-input-group>
              </b-form-group>
              </b-col>
          </b-row>
          </b-container>
        </template>
      </template>
    </c-modal>
  </b-container>
</template>

<script>
  import Mlabel from "../../../../shared/Mlabel";
  import { Switch as cSwitch } from '@/components/shared'
  import CurrencyDisplay from "../../../../shared/currencyDisplay";
  import config from "SrcConfig";
  import DeactiveFood from "./deactiveFood";
  import DeleteConfirmation from "./deleteConfirmation";
  import EditFood from "./editFood";
  import UploadPhoto from "../../../../shared/UploadPhoto";
  import ItemImage from "./itemImage";
  import ItemOptions from "./itemOptions";
  import StatusConfirmation from "./statusConfirmation";
  import CModal from "../../../../shared/Cmodal";
  export default {
    name: "foodItem",
    components: {
      StatusConfirmation,
      ItemOptions,
      ItemImage, UploadPhoto, EditFood, DeleteConfirmation, DeactiveFood, CurrencyDisplay, Mlabel, cSwitch, CModal},
    props: {
      value: {required: true, type: Object},
      edibleType: {
        required: true,
        type: String
      },
      category: {
        required: true,
        type: Object
      },
      AllowSecondLang: {
        required: true,
        type: Boolean,
        default: false
      },
      foods: {
        required: true,
        type: Array,
        default: []
      },
      kds: {
        required: true,
        type: String,
        default: ''
      },
      display: {
        required: true,
        type: String,
        default: ''
      },
      loyaltyPermission: {
        type: Boolean,
        default: false
      },
      loyaltyAllowance: {
        type: Boolean,
        default: false
      },
      loyaltyRewardsFull: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        deleteModal: false,
        deleteLoading: false,
        editModal: false,
        photoModal: false,
        photoTarget: 'primary photo',
        CreditName: false,
        CopyrightName: false,
        progressing: false,
        currentPhotoItemModal: false,
        confirmationChangeStatus: false,
        availableCategories:[],
        duplicateModal: false,
        duplicateLoading: false,
        destinationLoading: false,
        destinationMenuTypes: [],
        selectedMenuTypeID: null,
        selectedCategoryID: null
      }
    },
    computed: {
      getOptions () {
        const tags = [
          {text: 'Vegan', has: this.value.Vegan, bg: '#2E7D32', color: '#FFFFFF'},
          {text: 'Vegan Upon Request', has: this.value.VeganRequest, bg: '#E8F5E9', color: '#2E7D32'},
          {text: 'Veggie', has: this.value.Vegeterian, bg: '#AED581', color: '#185E20'},
          {text: 'Veggie Upon Request', has: this.value.VegeterianRequest, bg: '#F1F8E9', color: '#558B2F'},
          {text: 'Gluten Free', has: this.value.GlutenFree, bg: '#D4E157', color: '#4E342E'},
          {text: 'Gluten Free Upon Request', has: this.value.GlutenFreeRequest, bg: '#E0F2F1', color: '#00695C'},
          {text: 'Dairy Free', has: this.value.DairyFree, bg: '#2196F3', color: '#FFFFFF'},
          {text: 'Kosher', has: this.value.Kosher, bg: '#29999A', color: '#FFFFFF'},
          {text: 'Halal Meat', has: this.value.Halal, bg: '#448042', color: '#FFFFFF'},
          {text: 'Hot/Spicy', has: this.value.Hot, bg: '#D32F2F', color: '#FFFFFF'},
          {text: 'Hot/Spicy Upon Request', has: this.value.HotRequest, bg: '#FFEBEE', color: '#C62828'},
          {text: 'Raw/Undercooked', has: this.value.Uncooked, bg: '#EC407A', color: '#FFFFFF'},
          {text: 'Alcoholic', has: this.edibleType === 'Drink' && this.value.Alcoholic, bg: '#0277BD', color: '#FFFFFF'},
        ]
        return tags.filter(tag => tag.has)
      },
      currentPhoto () {
        return this.photoTarget === 'secondary photo' ? this.value.Photo2 : this.value.Photo1
      },
      priceCommentsList () {
        return [
          {text: 'Price', value: this.value.PriceComment},
          {text: 'Price', value: this.value.Price1Comment},
          {text: 'Price', value: this.value.Price2Comment},
          {text: 'Price', value: this.value.Price3Comment},
          {text: 'Price', value: this.value.Price4Comment},
        ].filter(item => item.value)
      },
      ShowPhotoFor: {
        get () {
          return this.priceCommentsList[0].value
        },
        set(val) {
          // this.$emit('input', val)
          console.log(val)
          // this.test = val
        }
      },
      destinationCategories () {
        const menuType = this.destinationMenuTypes.find(item => item.MenuTypeID === this.selectedMenuTypeID)
        return menuType ? menuType.categories : []
      },
      applicableLoyaltyRewards () {
        if (!this.loyaltyPermission) return []
        return this.loyaltyRewardsFull.filter(reward => {
          const scope = Array.isArray(reward.Scope) ? reward.Scope : []
          if (!scope.length || scope.some(s => s.ScopeKind === 'all')) return true
          return scope.some(s =>
            (s.ScopeKind === 'item' && s.RefID === this.value.ID && s.ItemCommodity === this.edibleType) ||
            (s.ScopeKind === 'category' && s.RefID === this.category.CategoryID) ||
            (s.ScopeKind === 'menu' && s.RefID === this.category.MenuTypeID)
          )
        }).sort((a, b) => (a.Status === 'active' ? 0 : 1) - (b.Status === 'active' ? 0 : 1))
      }
    },
    methods: {
      getAvailableCat(){
            //Get?RestaurantID=46&MenuTypeID=1299&EdibleType=Drink
            const filter = {
              RestaurantID: this.$store.state.selectedRestaurantId,
              MenuTypeID: this.category.MenuTypeID,
              EdibleType: this.edibleType,
            }
        this.$api.category.get(filter).then((res)=>{
          
          this.availableCategories =  res.data.categories
        })
      },
      getModifierName (value) {
        return value.ModifierCategories.map(item => item.ModifierCategory).join(', ')
      },
      getImage (photo) {
        if (photo) {
          let baseUrl = config.files.baseurlimage;
          if (config.files.baseurlimage.search('www') != -1) {
            baseUrl = "https://images.menupoly.com";
            return baseUrl + `/UserUpload/User_${localStorage.getItem('restaurantProfile')}/` + photo
          }
          return config.files.baseurlimage + `/UserUpload/User_${localStorage.getItem('restaurantProfile')}/` + photo
        } else {
          let baseUrl = config.files.baseurlimage;
          if (config.files.baseurlimage.search('www') != -1) {
            baseUrl = "https://images.menupoly.com";
            return baseUrl + '/Images/thumb_empty.png'
          }
          return config.files.baseurlimage + '/Images/thumb_empty.png'
        }
      },
      confirmationAvailable (val) {
        this.confirmationChangeStatus = true
        setTimeout(() => {
          this.value.IsAvailable = val
        })
      },
      changeAvailable ({food, changeAll}) {
        const model = {
          // UserID: localStorage.getItem('userID'),
          RestaurantID: this.$store.state.selectedRestaurantId,
          EdibleType: this.edibleType,
          Available: food.IsAvailable ? 0 : 1,
          AppendDuplicates: changeAll ? 1 : 0,
          Name: food.Name
        }
        this.deleteLoading = true
        return this.$api.foodDrink.updateAvailable(model, this.value.ID, true).then(() => {
          this.deleteLoading = false
          this.confirmationChangeStatus = false
          this.$emit('refresh', this.category)
        }).catch(err => {
          this.deleteLoading = false
          this.confirmationChangeStatus = false
        })
      },
      deleteConfirmation () {
        this.deleteModal = true
      },
      deleteFood ({food, deleteAll}) {
        const model = {
          // UserID: localStorage.getItem('userID'),
          RestaurantID: this.$store.state.selectedRestaurantId,
          EdibleType: this.edibleType,
          AppendDuplicates: deleteAll ? 1 : 0,
          Name: food.Name
        }
        this.deleteLoading = true
        return this.$api.foodDrink.delete(food.ID, model).then(() => {
          this.$emit('refresh', this.category)
          this.editModal = false
          this.deleteModal = false
          this.deleteLoading = false
        }).catch(() => {
          this.$showError('error')
          this.deleteLoading = false
        })
      },
      refreshFood (category) {
        this.$emit('refresh', category)
      },
      isMultiPrice (food) {
        const prices = [food.Price, food.Price1, food.Price2, food.Price3, food.Price4]
        return prices.filter(item => item >= 0).length > 1 ? true : false
      },
      showCalorie (food) {
        let colories = [food.Calories, food.Calories1, food.Calories2, food.Calories3, food.Calories4]
        let nonZiroColories = colories.filter(i => i > 0)
        return {
          hasCalorie: colories.filter(i => i > 0).length ? true : false,
          minCalorie: Math.min(...nonZiroColories),
          multiCalorie: colories.filter(i => i > 0).length > 1 ? true : false
        }
      },
      openEdit () {
        this.editModal = true
        this.getAvailableCat()
      },
      toggleChefPick () {
        this.$set(this.value, 'ChefPick', !this.value.ChefPick)
        const model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          EdibleType: this.edibleType,
          ChefPick: this.value.ChefPick ? 1 : 0,
          Name: this.value.Name
        }
        this.$api.foodDrink.UpdateItemChefPick(model, this.value.ID, true).then(() => {
          this.$emit('refresh', this.category)
        }).catch(() => {
          this.$showError('error on setting chef pick')
        })
      },
      openPhotoModal () {
        this.photoTarget = 'primary photo'
        this.photoModal = true
      },
      deletePhoto () {
        const model = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          EdibleType: this.edibleType,
          SelectedImage: this.photoTarget
        }
        this.progressing = true
        return this.$api.foodDrink.deletePhoto(model, this.value.ID).then(() => {
          this.progressing = false
          this.photoModal = false
          this.$emit('refresh', this.category)
        }).catch(() => {
          this.progressing = false
          this.$showError('error on delete photo')
        })

      },
      upload ({image, fileName, vertical=false}) {
        const splitedImage = image.split(',')[1]
        const photoFor = this.priceCommentsList.length ? document.getElementById('ShowPhotoFor').value : ''
        const model = {
          // UserID: localStorage.getItem("userID"),
          RestaurantID: this.$store.state.selectedRestaurantId,
          EdibleType: this.edibleType,
          FileName: fileName,
          CopyrightName: this.CopyrightName ? 1 : 0,
          CopyrightNameBlack: 0,
          CreditName: this.CreditName ? +localStorage.getItem('userID') : 0,
          ShowPhotoFor: photoFor,
          Photo: splitedImage,
          ImageOrientation: vertical ? "V" : "H",
          SelectedImage: this.photoTarget
        }
        this.progressing = true
        return this.$api.foodDrink.uploadPhoto(model, this.value.ID, true).then(() => {
          this.progressing = false
          this.photoModal = false
          this.$emit('refresh', this.category)
        }).catch(() => {
          this.progressing = false
          this.photoModal = false
          this.$showError('error on upload photo')
        })
      },
      showCurrentPhoto () {
        this.currentPhotoItemModal = true
      },
      duplicate () {
          this.duplicateModal = true
          this.selectedMenuTypeID = null
          this.selectedCategoryID = null
          this.getDestinationMenuTypes()
      },
      getDestinationMenuTypes () {
          const model = {
            RestaurantID: this.$store.state.selectedRestaurantId,
            EdibleType: this.edibleType
          }
          this.destinationLoading = true
          return this.$api.menuType.list(model).then(res => {
            const menuTypes = (res.data && res.data.menuTypes) || []
            return Promise.all(menuTypes.map(menuType => {
              const filter = {
                RestaurantID: this.$store.state.selectedRestaurantId,
                MenuTypeID: menuType.MenuTypeID,
                EdibleType: this.edibleType
              }
              return this.$api.category.get(filter).then(catRes => {
                const categories = (catRes.data && catRes.data.categories) || []
                return {
                  MenuTypeID: menuType.MenuTypeID,
                  Name: menuType.MenuType,
                  categories: categories.map(category => ({
                    CategoryID: category.CategoryID,
                    Name: category.CategoryDESC
                  }))
                }
              })
            }))
          }).then(destinationMenuTypes => {
            this.destinationMenuTypes = destinationMenuTypes.filter(menuType => menuType.categories.length > 0)
            this.destinationLoading = false
            const currentMenuType = this.destinationMenuTypes.find(menuType =>
              menuType.categories.some(category => category.CategoryID === this.category.CategoryID)
            )
            if (currentMenuType) {
              this.selectedMenuTypeID = currentMenuType.MenuTypeID
              this.selectedCategoryID = this.category.CategoryID
            } else if (this.destinationMenuTypes.length) {
              this.selectedMenuTypeID = this.destinationMenuTypes[0].MenuTypeID
            }
          }).catch(() => {
            this.destinationLoading = false
            this.destinationMenuTypes = []
            this.$showError('Error loading menu types')
          })
      },
      onMenuTypeChange () {
          this.selectedCategoryID = null
      },
      duplicateFood () {
          const destCategoryID = this.selectedCategoryID || this.category.CategoryID
          const model = {
            UserID: localStorage.getItem('userID'),
            RestaurantID: this.$store.state.selectedRestaurantId,
            ItemID: this.value.ID,
            ItemType: this.edibleType,
            DestMenuTypeID: this.selectedMenuTypeID,
            DestCategoryID: destCategoryID
          }
          this.duplicateLoading = true
          return this.$api.getRestaurant.DuplicateItem(model).then(res => {
            this.duplicateLoading = false
            if (res.success) {
              this.duplicateModal = false
              this.$emit('refresh', {CategoryID: destCategoryID})
            } else {
              this.$showError(res.message)
            }
          }).catch(() => {
            this.duplicateLoading = false
            this.$showError('error on duplicating item')
          })
      }
    }
  }
</script>
<style scoped>
  .greenText{
    color: #388e3c
  }
  .new-tag{
    background-image: none;
    position: absolute;
    position: absolute;
    left: -17px;
    top: 5px;
    transform: rotate(-45deg);
    height: 15px;
    z-index: 1;
    font-size: 0.8em;
    border-bottom: 21px solid red;
    border-left: 21px solid transparent;
    border-right: 21px solid transparent;
  }
  .credit-box{
    writing-mode: vertical-lr;
    right:0;
    bottom:0;
    position: absolute;
  }
  .photo-toggle-group{
    display: inline-flex;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    overflow: hidden;
  }
  .photo-toggle-btn{
    border: none;
    background: #fff;
    padding: 0.5rem 1.25rem;
    font-weight: 600;
    font-size: 0.9rem;
    color: #495057;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out, color 0.15s ease-in-out;
  }
  .photo-toggle-btn:not(:first-child){
    border-left: 1px solid #dee2e6;
  }
  .photo-toggle-btn:hover:not(.active){
    background: #f8f9fa;
  }
  .photo-toggle-btn.active{
    background: #ffc107;
    color: #212529;
  }

</style>
